import helper from '../helpers/ApiUrlHelper.js';
export default {
  async getCompanySettings() {
    let currentUrl = window.location.href;
    currentUrl = currentUrl.replace('/career/#/', '/').replace('/#/', '/');

    return await fetch(
      `${helper.apiUrl()}/company/getsettings?url=${currentUrl}`
    );
  },

  getDepartments(slug) {
    return fetch(`${helper.apiUrl()}/company/getdepartments/${slug}`);
  },

  getImprint(slug) {
    return fetch(`${helper.apiUrl()}/company/getImprint/${slug}`);
  },

  getLocaleSettings(slug) {
    return fetch(`${helper.apiUrl()}/company/getlocale/${slug}`);
  },

  getLocations(slug) {
    return fetch(`${helper.apiUrl()}/company/getlocations/${slug}`);
  },

  getPrivacyPolicy(slug) {
    return fetch(`${helper.apiUrl()}/company/getPrivacyPolicy/${slug}`);
  },

  getTranslations(slug, translationKey, jobofferId) {
    let url = `${helper.apiUrl()}/company/translations?slug=${slug}&translationKey=${translationKey}`;
    if (jobofferId) {
      url += `&jobofferId=${jobofferId}`;
    }

    return fetch(url);
  },

  getSkills(slug, jobofferId) {
    let url = `${helper.apiUrl()}/company/skills?slug=${slug}`;
    if (jobofferId) {
      url += `&jobofferId=${jobofferId}`;
    }

    return fetch(url);
  }
};
